import { useMutation, useQuery } from "@tanstack/react-query";
import { getCoupons, getRewards, referFriend } from "api/refer";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const usereferFriend = (options = {}) => {
  return useMutation({
    mutationFn: referFriend,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useCoupons = () => {
  return useQuery({
    queryKey: ["coupons"],
    queryFn: getCoupons,
  });
};

export const useRewards = () => {
  return useQuery({
    queryKey: ["rewards"],
    queryFn: getRewards,
  });
};
